import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CampaignStructureLevel } from '../../api/models';

@Injectable()
export class LeftMenuService {
	static leftMenuLevelChange$ = new Subject<CampaignStructureLevel>();
    constructor() {}
}
